module.exports = __webpack_public_path__ + "static/media/icon-pencil.83d696ee.svg";